<template>
  <div class="message-wrapper">
    <h4 class="title">未读留言</h4>
    <ul class="list-box" v-if="msgList.length!=0">
      <li class="list-item clearfix" v-for="item in msgList" @click="showBox(item.user_id, item)">
        <div class="left-box">
          <img width="60" height="60" v-if="users[item.user_id].user_logo.indexOf('?')==0" src="../../../images/personal_center/avatar_default.png" alt="">
          <img width="60" height="60" v-else :src="users[item.user_id].user_logo" alt="">
        </div>
        <div class="right-box">
          <p class="user-name">{{users[item.user_id].nick_name}}</p>
          <div class="content clearfix">
            <div class="msg-content"><i class="icon icon-upload"></i><span class="message" v-html="item.content"></span></div>
            <div class="msg-detail">
              <span class="dialog-num"><i class="icon icon-dialog"></i><span>{{item.msg_cnt}}</span></span>
              <span class="last-time"><i class="icon icon-clock"></i><span>{{item.create_time}}</span></span>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div class="msg-empty" v-else>
      <img src="../../../images/personal_center/work-null.png" alt="">
      <p>当前没有未读的留言消息</p>
    </div>
    <button type="button" name="button" class="more" v-if="page.totalPage>page.curPage" @click="getMsgList(parseInt(page.curPage)+1)">
      <span v-if="!isLoading">加载更多</span>
      <img src="../../../images/common/loading_2_24x24.gif" alt="">
    </button>
    <message-box :msgItem="msgItem" :isBoxShow="isBoxShow" v-on:closeBox="closeBox" :uid="uid"></message-box>
  </div>
</template>

<script type="text/javascript">
  import messageBox from "./message_box.vue"
  export default {
    data() {
      return {
        msgList: [],
        page: {
          curPage: 1,
          totalPage: 1,
          total: 0
        },
        users: [],
        isBoxShow: false,  // 留言框显示状态
        uid: 0,
        isLoading: false,
        msgItem: {}        // 当前弹窗的对象
      }
    },
    methods: {
      /*
        显示留言弹窗
        uid  对方user_id
      */
      showBox(uid, item) {
        this.isBoxShow = true;
        this.msgItem = item;
        this.uid = uid;
      },
      closeBox() {
        this.isBoxShow = false;
        this.uid = 0;
      },
      /*
        获取留言列表
      */
      getMsgList(curPage) {
        this.isLoading = true;
        axios.post(myUrl + "sns/message/", qs.stringify({
          page: curPage,
          is_read: "unread"
        })).then((res) => {
          res = res.data;
          if (res.result) {
            this.msgList = this.msgList.concat(res.data.items);
            this.page = res.data.page;
            for (let key in res.data.users){
              this.users[key] = res.data.users[key];
            }
          }
          this.isLoading = false;
        }).catch(() => {
          this.isLoading = false;
        })
      }
    },
    mounted() {
      this.getMsgList(1);  // 加载第一页
    },
    components: {
      messageBox
    }
  }
</script>

<style media="screen" lang="scss" scoped>
  .message-wrapper{
    min-height: 640px;
    padding: 15px 45px 65px;
    .title{
      padding: 20px 0;
      font-size: 18px;
      font-weight: bold;
      color: #77787f;
      border-bottom: 1px solid #f4f4f4;
    }
    .list-box{
      margin-top: 18px;
      .list-item{
        padding: 15px 0 15px 16px;
        border-bottom: 1px solid #f4f4f4;
        cursor: pointer;
        .icon{
          width: 14px;
          height: 14px;
          display: inline-block;
        }
        .icon-upload{
          background: url(../../../images/personal_center/icon-upload.png)
        }
        .icon-clock{
          background: url(../../../images/personal_center/icon-clock.png)
        }
        .icon-dialog{
          width: 16px;
          background: url(../../../images/personal_center/icon-dialog.png)
        }
        .message{
          width: 450px;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .left-box{
          margin-right: 16px;
          float: left;
        }
        .right-box{
          float: left;
          padding-top: 12px;
          font-size: 14px;
          line-height: 14px;
          width: 729px;
          .user-name{
            color: #444;
          }
          .content{
            margin-top: 12px;
            .msg-content{
              float: left;
              color: #aaaaaa;
              .icon-upload{
                margin-right: 10px;
              }
            }
            .msg-detail{
              float: right;
              font-size: 12px;
              .dialog-num{
                display: inline-block;
                width: 38px;
                margin-right: 24px;
              }
              .last-time{
                display: inline-block;
                width: 72px;
              }
              .dialog-num,.last-time{
                span{
                  float: right;
                }
              }
            }
          }
        }
      }
    }
    .more{
      margin-top: 20px;
      display: block;
      width: 100%;
      height: 42px;
      line-height: 42px;
      border: 1px solid #f4f4f4;
      text-align: center;
      font-size: 14px;
      color: #828282;
      background: #fff;
      outline: none;
      &:hover{
        background: #fafafa;
      }
    }
    .msg-empty{
      padding: 120px 0;
      text-align: center;
      img{
        margin-bottom: 25px;
      }
      p{
        font-size: 16px;
        color: #878996;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// unread.vue?1eb824a6